import { AbstractConnector } from '@web3-react/abstract-connector'
import { JSBI, Percent, Token } from '@uniswap/sdk'

import { injected } from '../connectors'
import { COMMON_BASES, PRIMARY_BASES, ROUTER_ADDRESS, SUPPORTED_CHAIN_ID, WRAPPED_NATIVE } from '../chainConfig'

export { ROUTER_ADDRESS, SUPPORTED_CHAIN_ID }

// a list of tokens by chain
type ChainTokenList = {
  readonly [chainId: number]: Token[]
}

const WETH_ONLY: ChainTokenList = {
  [SUPPORTED_CHAIN_ID]: [WRAPPED_NATIVE]
}

// used to construct intermediary pairs for trading
export const BASES_TO_CHECK_TRADES_AGAINST: ChainTokenList = {
  ...WETH_ONLY,
  [SUPPORTED_CHAIN_ID]: PRIMARY_BASES
}

// used for display in the default list when adding liquidity
export const SUGGESTED_BASES: ChainTokenList = {
  ...WETH_ONLY,
  [SUPPORTED_CHAIN_ID]: COMMON_BASES
}

// used to construct the list of all pairs we consider by default in the frontend
export const BASES_TO_TRACK_LIQUIDITY_FOR: ChainTokenList = {
  ...WETH_ONLY,
  [SUPPORTED_CHAIN_ID]: PRIMARY_BASES
}

export const PINNED_PAIRS: { readonly [chainId: number]: [Token, Token][] } = {
  [SUPPORTED_CHAIN_ID]: []
}

export interface WalletInfo {
  connector?: AbstractConnector
  name: string
  iconName: string
  description: string
  href: string | null
  color: string
  primary?: true
  mobile?: true
  mobileOnly?: true
}

export const SUPPORTED_WALLETS: { [key: string]: WalletInfo } = {
  INJECTED: {
    connector: injected,
    name: 'Injected',
    iconName: 'arrow-right.svg',
    description: 'Injected web3 provider.',
    href: null,
    color: '#010101',
    primary: true
  },
  METAMASK: {
    connector: injected,
    name: 'MetaMask',
    iconName: 'metamask.png',
    description: 'Easy-to-use browser extension.',
    href: null,
    color: '#E8831D'
  }
}

export const NetworkContextName = 'NETWORK'

// default allowed slippage, in bips
export const INITIAL_ALLOWED_SLIPPAGE = 50
// 20 minutes, denominated in seconds
export const DEFAULT_DEADLINE_FROM_NOW = 60 * 20

// one basis point
export const ONE_BIPS = new Percent(JSBI.BigInt(1), JSBI.BigInt(10000))
export const BIPS_BASE = JSBI.BigInt(10000)
// used for warning states
export const ALLOWED_PRICE_IMPACT_LOW: Percent = new Percent(JSBI.BigInt(100), BIPS_BASE) // 1%
export const ALLOWED_PRICE_IMPACT_MEDIUM: Percent = new Percent(JSBI.BigInt(300), BIPS_BASE) // 3%
export const ALLOWED_PRICE_IMPACT_HIGH: Percent = new Percent(JSBI.BigInt(500), BIPS_BASE) // 5%
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
export const PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN: Percent = new Percent(JSBI.BigInt(1000), BIPS_BASE) // 10%
// for non expert mode disable swaps above this
export const BLOCKED_PRICE_IMPACT_NON_EXPERT: Percent = new Percent(JSBI.BigInt(1500), BIPS_BASE) // 15%

// used to ensure the user does not spend the entire native balance
export const MIN_NATIVE_CURRENCY: JSBI = JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(16))
